{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "添加更多图片"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "批准"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "返回"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "返回登录"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "客房账单"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "购买更多"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "取消"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "关闭"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "完成购买"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "继续"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "信用卡或借记卡"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "完成"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "下载"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "编辑订单"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "进入"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "遗忘"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "已了解"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "下一个（右箭头）"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "上一个（左箭头）"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "放大/缩小"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "注销"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "登录"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "查找图库"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "更多图片"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "新订单"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "确定"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "价格指南"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "打印"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "流程"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "购买"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "刷新"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "移除"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "移除打印"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "审查和购买"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "选择"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "选定的打印尺寸（"
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": "）"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "发送一个链接"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "发送多个链接"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "分享"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "留在这里"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "条纹阅读器"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "查看图库"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "查看我的图库"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "查看收据"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "您可以免费添加更多图片"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "应用"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "购买所有图片的价格为 "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买所有图片"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买全部"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "购物车详情"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "购物车共计"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "结账"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "优惠券代码"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "信用卡或借记卡"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "数字版图片"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "购买更多图片以获取折扣"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "此 "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " 将免费提供。"
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "您的图库链接已发送至 "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "请在结账前选择要购买的图片"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "在 "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买 "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买所有图片"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买 "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " 图片"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买 "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " 张"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 0,
      "value": "以 "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " 购买 "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": "-"
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " 张"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "价格指南"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "请参阅价格指南，了解定价"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "购买"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "已购买"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "购买"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "对不起，我们遇到问题，导致扣款不成功。请重试，如果问题仍然存在，请联系我们。"
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "标准价格为每张 "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "感谢您的购买！"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "共计"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "所有数字版图片"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "所有数字版图片和打印版图片"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "未购买"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "查看照片"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "购买 "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " 并获得 "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " 折扣"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 0,
      "value": "购买 "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " 张或以上即可获得 "
    },
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " 折扣"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "使用 Capturelife 即表示您同意我们的 "
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "输入并请确认您的密码。"
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "密码确认"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "联系我们"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "电子邮件或电话"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "电子邮件地址或电话号码"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "电子邮件"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "请输入电子邮件地址。"
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "请输入密码。"
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "请输入有效的电子邮件地址或电话号码。"
    }
  ],
  "consumer_enter_valid_email_phone_": [
    {
      "type": 0,
      "value": "请输入有效的电子邮件地址或电话号码。"
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD（魔法世界）及所有相关商标、人物、名称和标记的版权 © 和商标 ™ 均系 Warner Bros. Entertainment Inc. 所有。出版权 © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "输入您的电子邮件地址或电话号码以重置您的密码"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "遗忘您的密码？"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "打印商店"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "生成二维码"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "抱歉，此链接已过期。 请输入您的电子邮件或电话号码以接收另一个链接。"
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "正在登录..."
    }
  ],
  "consumer_logging_in_button": [
    {
      "type": 0,
      "value": "正在登录..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "让我们返回捕捉这些瞬间！"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "哎呀，您似乎遗漏了一些内容。"
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "我的个人数据"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "添加照片"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "添加"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "返回"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "下载"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "主页"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "注销"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "新闻"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "打印商店"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "个人资料"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "刷新"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "分享"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "您的密码不得少于 "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " 个字符。"
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "密码"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "您的密码和密码确认不符。"
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "请截取您的二维码或点按下方的下载按钮"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "重置密码"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "重置密码..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "选择全部"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "要下载或共享图片，请长按此图片以显示设备的共享选项。"
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "网上商店"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "使用条款"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "请输入您想要使用的电子邮件和密码。"
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "更新密码"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "更新您的密码"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "更新密码..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "欢迎回来！"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "无法应用折扣代码。 购买总额低于最低要求金额"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "未找到折扣代码"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "请输入真实的电子邮件地址。"
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "请输入您的电子邮件地址。"
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "请填写以下字段。"
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "未找到预订。"
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "此帐户没有照片。 请扫描相片中心使用的范围"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "此帐户没有照片。 请咨询摄影师或管理人员"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "信用卡或借记卡"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "电子邮件"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "电子邮件"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "姓氏"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "密码"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "PIN 码"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "价格（"
    },
    {
      "type": 1,
      "value": "货币"
    },
    {
      "type": 0,
      "value": "）"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "房间号"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "密码"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "选择全部"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "解锁所有图片"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "需要批准"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "请求帮助"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "批准购买"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "输入此次购买的价格。"
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "您将在 "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 秒"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 秒"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    },
    {
      "type": 0,
      "value": "后自动注销"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "哈罗，你还在吗？"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "审查和购买"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "点按 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " 以从您的购物车中移除图片。 点按 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "完成购买"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 以继续。"
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "将图片添加到您的图库"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "选择要购买的图片"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "点按图片，将其添加到您的图库。 点按 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "查看我的图库"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 以返回您的图库。"
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "点按图片，将其添加到您的订单中。点按 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "查看和购买"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 以继续。"
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "加载图片..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "选择和购买"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "您的图片库"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "选择和打印"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "您的图片库"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "点按图片以选择购买。点按 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "buttonLabel"
    },
    {
      "type": 0,
      "value": " 以继续。"
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "您的图库为空白。 点按屏幕界面右上角的 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "更多图片"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 以浏览可用的图片。"
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "点按图片上的打印图标，选中以打印。 点按打印按钮，下载选定的图片"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "点按图片以选择购买。双击以订购打印版图片。点按 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "buttonLabel"
    },
    {
      "type": 0,
      "value": " 以继续。"
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "您已解锁所有图片。 点按 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " 以从您的图库中删除。"
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "您已解锁所有图片。 点按图片以订购打印版图片。点按 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " 以从您的图库中删除。"
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "添加打印"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "已购买数字版图片"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "已购买打印版图片"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "已选定打印版图片"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "移除打印版图片"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "选择打印版图片"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "您的图片"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "选择多张图片"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "您的选择"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "访问您的图片"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "输入您的房间号、姓氏和电子邮件，以访问您的图库"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "欢迎！"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "WIZARDING WORLD（魔法世界）及所有相关商标、人物、名称和标记的版权 © 和商标 ™ 均系 Warner Bros. Entertainment Inc. 所有。出版权 © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_clubmed": [
    {
      "type": 0,
      "value": "输入您的房间号、姓氏和电子邮件，以访问您的图库"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "请输入您的电子邮件地址以继续。"
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "扫描您的腕带以开始"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "客房账单"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "以下款项总额将计入您的客房账单"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "完成购买"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "您的订单包括："
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* 所有销售均为最终销售，无法提供退款。"
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "订单详情"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "点按左侧的图片以选择购买。"
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "您的购物车是空的。点按图片，将其添加到您的订单中。"
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "您的购物车是空的。点按 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "添加更多图片"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 以添加更多图片"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "您将通过电子邮件收到您的图片"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "双击图片以订购打印版图片。"
    }
  ],
  "kiosk_order_details_line_item_digitals": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张数字版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_prints": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " 张打印版图片"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "kiosk_order_details_line_item_unlock_all": [
    {
      "type": 0,
      "value": "所有数字版图片"
    }
  ],
  "kiosk_order_details_line_item_unlock_all_prints": [
    {
      "type": 0,
      "value": "所有数字版图片和打印版图片"
    }
  ],
  "kiosk_order_details_total": [
    {
      "type": 0,
      "value": "共计："
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "完成购买"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "您希望以何种方式完成购买？"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "价格指南"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "购买更多图片以获取折扣"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "标准价格为每张图片 "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "您可以免费添加更多图片"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "打印尺寸"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "选择打印尺寸和计数"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "处理付款..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "提供的折扣："
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "提供的套餐："
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 0,
      "value": "每张图片 "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "标准价格："
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "总计："
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "点按图片，将其添加到您的订单中"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "点按图片以选择购买或取消选择。要从您的选择中添加更多图片，请点按 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "更多图片"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "。"
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "阅读器未连接"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "阅读器无法处理"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "阅读器待机..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "购买完成"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "您的图库链接已发送至 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": "。"
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "您是否希望从订单中移除此图片？您将需要通过点按 "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "添加更多图片"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " 才能再次找到该图片。"
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "房间 "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "房间 "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "链接已通过电子邮件发送到 "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "email"
    },
    {
      "type": 0,
      "value": "。"
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "纵横比"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "选定的打印"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "时刻"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "计数"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "打印尺寸"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "完成购买"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "输入付款信息"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "欢迎，"
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "！"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "欢迎，"
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": "！"
    }
  ]
}